import React from "react";
import { VoiceInterface } from "@/components/voice/VoiceInterface";

type State = { hasError: boolean };

/**
 * Protege o app de crashes causados por erros de render/hook na interface de voz.
 * Em caso de erro, apenas esconde o widget (evita tela branca).
 */
export class VoiceInterfaceBoundary extends React.Component<{}, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: unknown) {
    console.error("[VoiceInterfaceBoundary] crashed:", error, info);
  }

  render() {
    if (this.state.hasError) return null;
    return <VoiceInterface />;
  }
}
